
























import { Component, Prop, Vue } from 'vue-property-decorator';
import SelectItem from '@/common/SelectItem';
import { BooleanService } from '@/services/util/BooleanService';

@Component({})
export default class CustomSelectTh extends Vue {

  get current(): SelectItem {
    return this.pAll[this.selectedIndex];
  }

  get pAll(): SelectItem[] {
    return this.deserializeList(this.localAll);
  }

  get getSelectedIndex(): number {
    if (this.selectedIndex === -1) {
      this.selectedIndex = this.initialIndex;
    }
    return this.selectedIndex;
  }

  get onChangeSubmit(): boolean {
    return BooleanService.fromString(this.localOnChangeSubmit);
  }

  get initialIndex(): number {
    return Number.parseInt(this.localInitialIndex, 10);
  }

  @Prop({required: true})
  public localAll: string;

  @Prop({required: true})
  public localName: string;

  @Prop({required: false})
  public localOnChangeSubmit: string;

  @Prop({required: false, default: '0'})
  public localInitialIndex: string;

  @Prop({required: false, default: 'sc-select'})
  public localStyleClass: string;

  public selectedIndex: number = -1;
  public opened = false;

  public toggle() {
    if (this.pAll.length > 1) {
      if (this.opened) {
        this.close();
      } else {
        this.open();
      }
    }
  }

  public open() {
    this.opened = true;
    document.body.addEventListener('click', this.close);
  }

  public close() {
    this.opened = false;
    document.body.removeEventListener('click', this.close);
  }

  public select(index: number) {
    this.selectedIndex = index;
    this.$emit('element-selected', this.pAll[index].key);
    if (this.onChangeSubmit) {
      const selectElement = this.$refs.selectInput as HTMLSelectElement;
      selectElement.selectedIndex = index;
      selectElement.form.submit();
    }
  }

  private deserializeList(str: string): SelectItem[] {
    return str.split(';;').map(this.deserialize);
  }

  /**
   * Turns serialised string of the form "key1::value::key2::value" to an object,
   * @note: Doesn't validate correctness!
   * @param str
   */
  private parseObj(str: string): object {
    const result = {};
    if (!str) {
      return result;
    }
    const split = str.split('::');
    for (let index = 0; index < split.length; index = index + 2) {
      result[split[index]] = result[split[index + 1]];

    }
    return result;
  }

  private deserialize(str: string): SelectItem {
    const split = str.split('::');
    return new SelectItem(split[0], [split[1]], this.parseObj(split[2]));
  }
}
